import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  const createledgeraccount = {
    label: "Create Ledger Account",
    pageLabel: "Create Ledger Account",
    starting: true,
    url: "createledgeraccount",
    pageType: "history",
    formTabs: {
        allTabs: [
          { label: "Ledger Defination", uid: "legderdefination", style: { fontFamily: "verdana" } },
           
        ]
      },
    
    form: [
        {
            widths: "col-sm-12",
            tab: "legderdefination",
            subComponents: [

        {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Ledger Control",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Account Group",
            label: "Account Group",
            name: "Account_Group",
            description: "Account Group"
          },
          {
            inputType: "autocomplete",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Account Group",
            name: "Account_Group",
            description: "Account Group"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Active",
            label: "Active",
            name: "Active",
            description: "Active"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Ledger Account",
            name: "",
            description: ""
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Ledger Account",
            name: "Ledger_Account",
            description: "Enter Ledger Account "
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Account Type",
            label: "Account Type",
            name: "Account_Type",
            description: "Account Type"
          },
          {
            inputType: "autocomplete",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Account Type",
            name: "Account_Type",
            description: "Account Type"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
        ]
    },
    {
        widths: "col-sm-12",
        tab: "legderdefination",
        subComponents: [
            {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-12",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Ledger Defination",
                name: "",
                description: ""
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Display Name",
                name: "",
                description: ""
              },
              {
                inputType: "text",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "displayname",
                description: "enter display name"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Short Name",
                name: "",
                description: ""
              },
              {
                inputType: "text",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "shortname",
                description: "enter Short name"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Description",
                name: "",
                description: ""
              },
              {
                inputType: "text",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "Description",
                description: "enter Description"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Search String",
                name: "",
                description: ""
              },
              {
                inputType: "text",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "Search_String",
                description: "enter Search String"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Description in Marathi",
                name: "",
                description: ""
              },
              {
                inputType: "text",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "Description_Marathi",
                description: "enter Description in Marathi"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Reference Account",
                name: "",
                description: ""
              },
              {
                inputType: "text",
                widths: {
                  parent: "col-sm-3",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "Reference_Account",
                description: "Enter Reference Account"
              },


        ]
    },
    {
        widths:"col-sm-12",
        tab:"legderdefination",
        subComponents:[
            {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-12",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "Ledger Management",
                name: "",
                description: ""
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "Credit Voucher Print",
                label: "Credit Voucher Print",
                name: "Credit_Voucher",
                description: "Credit Voucher Print"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "Allow CR Balance",
                label: "Allow CR Balance",
                name: "Allow_Balance",
                description: "Allow CR Balance"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "Debit Voucher Print",
                label: "Debit Voucher Print",
                name: "Debit_Voucher",
                description: "Debit Voucher Print"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "Allow DR Balance",
                label: "Allow DR Balance",
                name: "Allow_DRBalance",
                description: "Allow DR Balance"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "Product Attached",
                label: "Product Attached",
                name: "Product_Attached",
                description: "Product Attached"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "Allow NEFT/RTGS",
                label: "Allow NEFT/RTGS",
                name: "Allow_NEFT/RTGS",
                description: "Allow NEFT/RTGS"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "HO GL",
                label: "HO GL",
                name: "HOGL",
                description: "HO GL"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "CIN Compulsory",
                label: "CIN Compulsory",
                name: "CIN_Compulsory",
                description: "CIN Compulsory"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "CIN Allowed",
                label: "CIN Allowed",
                name: "CIN_Allowed",
                description: "CIN Allowed"
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "HSN",
                name: "",
                description: ""
              },
              {
                inputType: "text",
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "HSN",
                description: ""
              },
              {
                inputType: "displaytext",
                widths: {
                  parent: "col-sm-2",
                  children: "col-sm-12"
                },
                placeHolder: "",
                label: "",
                name: "",
                description: ""
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "CGST Bifercation Required",
                label: "CGST Bifercation Required",
                name: "CGST",
                description: "CGST Bifercation Required"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "Credit Transactions Allowed in Branches",
                label: "Credit Transactions Allowed in Branches",
                name: "creditbranches",
                description: "Credit Transactions Allowed in Branches"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "Transactions Allowed",
                label: "Transactions Allowed",
                name: "Transactions_Allowed",
                description: "Transactions Allowed"
              },
              {
                inputType: "checkbox",
                isRequired: true,
                default: "false",
                widths: {
                  parent: "col-sm-6",
                  children: "col-sm-12"
                },
                placeHolder: "Debit Transactions Allowed in Branches",
                label: "Debit Transactions Allowed in Branches",
                name: "debitbranches",
                description: "Debit Transactions Allowed in Branches"
              },

        ]
    }
          
    ]
};
export default createledgeraccount;